import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import SRTreadyImage from "../../assets/img/SRT_ready-small.png";
import vividCoreImage from "../../assets/img/vividcore-small.png";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Grid fluid>
          <nav className="pull-left">
            <ul>
              <li>
              <p style={{paddingTop:10 + "px"}}>
                  <img src={vividCoreImage} alt="SRT Ready" />
                </p>
              </li>
              <li>
                <p>
                  <img src={SRTreadyImage} alt="SRT Ready" />
                </p>
              </li>
              <li>
                <a
                  href="mailto:support@rccfiber.com?Subject=Support%20Request"
                  target="_top"
                >
                  Support Email: support@rccfiber.com
                </a>
              </li>
            </ul>
          </nav>
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            <a href="#">Radiant Communications Corp</a>
          </p>
          <p className="pull-right" />
        </Grid>
      </footer>
    );
  }
}

export default Footer;
